
// apiService.js
import { API_PASSWORD } from './config';
import { getSubdomain, fetchWithAuth } from './helpers';


/////////////////////////////// DASHBOARD///////////////////////
// /////////////////////////////////Public data///////////////////////////////////////////////////////////////////////////////////
// جلب البيانات العامة من السيرفر مع التوكن
export const fetchPublicData = async () => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/public/data`;

  console.log("🔍 محاولة جلب البيانات العامة من:", apiUrl);

  // ✅ إرسال الطلب مع التوكن
  const response = await fetchWithAuth(apiUrl, { method: "GET" }, false, true);

  if (!response.ok) {
    console.error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
    throw new Error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
  }

  const data = await response.json();

  if (!data || Object.keys(data).length === 0) {
    console.warn("⚠️ البيانات المسترجعة فارغة، سيتم استخدام القيم الافتراضية.");
    return { name: "بيانات غير متوفرة", logo: "https://via.placeholder.com/100" };
  }
  console.log("📢 استجابة API:", response);


  return data;
};

// export const fetchPublicDataForInvoice = async () => {
//   const subdomain = getSubdomain();
//   if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

//   const apiUrl = `https://${subdomain}.restocash.app/api/public/data`;
//   console.log("🔍 محاولة جلب البيانات العامة من:", apiUrl);

//   const response = await fetchWithAuth(apiUrl, { method: "GET" }, false, true);

//   if (!response.ok) {
//     console.error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
//     throw new Error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
//   }

//   const resData = await response.json();
//   console.log("📢 تم استرجاع البيانات العامة بنجاح:", resData);

//   // ✅ الوصول للبيانات الصحيحة داخل التعشيش
//   const data = resData?.data?.data || {};

//   let logoUrl = data.logo;
//   if (logoUrl && !logoUrl.startsWith("http")) {
//     logoUrl = `https://${subdomain}.restocash.app/${logoUrl.replace(/^\/+/, "")}`;
//   }

//   return {
//     name: data.name || "بيانات غير متوفرة",
//     logo: logoUrl || "https://via.placeholder.com/100",
//   };
// };

export const fetchPublicDataForInvoice = async () => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/public/data`;
  console.log("🔍 محاولة جلب البيانات العامة من:", apiUrl);

  const response = await fetchWithAuth(apiUrl, { method: "GET" }, false, true);
  if (!response.ok) {
    console.error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
    throw new Error(`❌ فشل في جلب البيانات العامة. الحالة: ${response.status}`);
  }

  const resData = await response.json();
  console.log("📢 البيانات الكاملة:", resData);

  // ✅ الوصول للبيانات الفعلية
  const data = resData?.data?.data || {};

  // تصحيح مسار اللوجو لو ناقص
  let logoUrl = data.logo;
  if (logoUrl && !logoUrl.startsWith("http")) {
    logoUrl = `https://${subdomain}.restocash.app/${logoUrl.replace(/^\/+/, "")}`;
  }

  // ✅ تأكد إننا بنرجّع كل القيم بوضوح
  return {
    name: data.name || "بيانات غير متوفرة",
    logo: logoUrl || "https://via.placeholder.com/100",
    address: data.address || "",
    phone: data.phone || "",
    invoice_note_printer: data.invoice_note_printer || "",
  };
};



export const updatePublicData = async (formData) => {
  const subdomain = getSubdomain();
  if (!subdomain) throw new Error("❌ خطأ: لم يتم العثور على subdomain.");

  const apiUrl = `https://${subdomain}.restocash.app/api/edite/public/data`;

  console.log("🔄 محاولة تحديث البيانات العامة:", apiUrl);

  // ✅ إرسال الطلب مع التوكن
  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    body: formData,
  }, true, true); // `true` لأنه يحتوي على `FormData` و `true` لأنه يتطلب التوكن

  if (!response.ok) {
    console.error(`❌ فشل في تحديث البيانات العامة. الحالة: ${response.status}`);
    throw new Error(`❌ فشل في تحديث البيانات العامة. الحالة: ${response.status}`);
  }

  return response.json();
};



////////////////////////////////////Branches -  الفروع////////////////////////////////////////////////////////////////////////////////////

// 🟢 1. جلب الفروع النشطة
export const fetchActiveBranches = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/root/data?api_password=${API_PASSWORD}`;

  console.log("📌 إرسال طلب لجلب الفروع النشطة:", apiUrl);

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) {
    console.error("❌ فشل في جلب الفروع النشطة.", response.status);
    throw new Error("❌ فشل في جلب الفروع النشطة.");
  }

  const result = await response.json();
  console.log("✅ بيانات الفروع النشطة المستلمة:", result);

  // ✅ ضمان إرجاع مصفوفة حتى لو لم تكن هناك بيانات
  return result?.data?.data ?? [];
};

// 🔴 2. جلب الفروع غير النشطة
// 🔴 جلب الفروع غير النشطة
export const fetchInactiveBranches = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/unactive/root?api_password=${API_PASSWORD}`;

  console.log("📌 جلب الفروع غير النشطة...");

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) throw new Error("❌ فشل في جلب الفروع غير النشطة.");
  
  return response.json();
};


// 🔄 3. إنشاء فرع جديد
export const createBranch = async (branchData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/root?api_password=${API_PASSWORD}`;

  const formData = new FormData();
  formData.append("name", branchData.name);
  formData.append("address", branchData.address);

  console.log("📌 إرسال طلب إنشاء فرع جديد:", formData);

  const response = await fetchWithAuth(apiUrl, { 
    method: "POST", 
    body: formData 
  }, true); // `true` لأننا نستخدم FormData

  if (!response.ok) throw new Error("❌ فشل في إنشاء الفرع الجديد.");
  
  return response.json();
};

// 4.✏️ تعديل بيانات الفرع
export const editBranch = async (branchData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/edite/root?api_password=${API_PASSWORD}`;

  const formData = new FormData();
  formData.append("id", branchData.id);
  formData.append("name", branchData.name);
  formData.append("address", branchData.address);

  console.log("🔄 إرسال طلب تعديل فرع:", formData);

  const response = await fetchWithAuth(apiUrl, { 
    method: "POST", 
    body: formData 
  }, true); // `true` لأننا نستخدم FormData

  if (!response.ok) throw new Error("❌ فشل في تعديل بيانات الفرع.");
  
  return response.json();
};

// 🔄 5. تغيير حالة الفرع بين نشط وغير نشط
export const changeBranchStatus = async (branchId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/change/root/status/${branchId}?api_password=${API_PASSWORD}`;

  console.log(`🔄 إرسال طلب تغيير حالة الفرع ID: ${branchId}`);

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) throw new Error("❌ فشل في تغيير حالة الفرع.");
  
  return response.json();
};

// 📌 6. جلب مجموعات الفروع بناءً على فرع معين
// 📌 جلب مجموعات الفروع بناءً على ID الفرع
export const fetchBranchGroups = async (branchId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/root/branchs/${branchId}?api_password=${API_PASSWORD}`;

  console.log(`📌 جلب المجموعات داخل الفرع ID: ${branchId}`);

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) throw new Error("❌ فشل في جلب مجموعات الفروع.");
  
  return response.json();
};





//////////////////////////////////////////////////////////////// Kitchens - المطبخ//////....................../////////////

//1. 🟢 جلب بيانات المطابخ
export const fetchKitchens = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/kitchens?api_password=${API_PASSWORD}`;

  console.log("📌 جلب بيانات المطابخ...", apiUrl);

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) throw new Error("❌ فشل في جلب بيانات المطابخ.");

  const result = await response.json();
  console.log("✅ بيانات المطابخ المستلمة:", result);
  return result?.data?.data ?? [];
};
// 2.تعديل بيانات المطابخ
export const editKitchen = async (kitchenData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/kitchen?api_password=${API_PASSWORD}`;

  const token = localStorage.getItem("token"); // ✅ جلب التوكين من LocalStorage

  if (!token) {
    throw new Error("❌ لا يوجد توكين، يرجى تسجيل الدخول!");
  }

  // ✅ التحقق من وجود root_id قبل الإرسال
  if (!kitchenData.root_id) {
    throw new Error("❌ يجب إدخال Root ID قبل إرسال الطلب.");
  }

  const formData = new FormData();
  formData.append("id", kitchenData.id);
  formData.append("name", kitchenData.name);
  formData.append("root_id", kitchenData.root_id); // ✅ تأكد من استخدام root_id بدلاً من root

  console.log("🔄 إرسال طلب تعديل بيانات المطبخ:", Object.fromEntries(formData));

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`, // ✅ إرسال التوكين مع الطلب
    },
    body: formData,
  });

  if (!response.ok) {
    const errorMessage = await response.text();
    throw new Error(`❌ فشل في تعديل بيانات المطبخ. استجابة الخادم: ${errorMessage}`);
  }

  return response.json();
};

// 3.🔄 تغيير حالة المطبخ (نشط / غير نشط)
export const changeKitchenStatus = async (kitchenId) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/change/kitchen/status/${kitchenId}?api_password=${API_PASSWORD}`;

  console.log(`🔄 تغيير حالة المطبخ ID: ${kitchenId}`);

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) throw new Error("❌ فشل في تغيير حالة المطبخ.");

  return response.json();
};

//4. 🔄 إنشاء مطبخ جديد
export const createKitchen = async (kitchenData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/new/kitchen`;

  const formData = new FormData();
  formData.append("api_password", API_PASSWORD);
  formData.append("name", kitchenData.name);
  formData.append("root_id", kitchenData.root_id);

  console.log("📌 إرسال طلب إنشاء مطبخ جديد:", Object.fromEntries(formData.entries()));

  return await fetchWithAuth(apiUrl, { method: "POST", body: formData }, true, true);
};











////////////////////////////////////////////////Tables - الطاولات/////////////////////////////////////////////////////////////////////
// 2.عرض بيانات الطاولات
export const fetchTables = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/tables`;

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) {
    throw new Error(`❌ فشل في جلب الطاولات. استجابة الخادم: ${await response.text()}`);
  }

  const data = await response.json();
  return data.data.data;
};

// ✅ جلب الطاولات غير النشطة
export const fetchInactiveTables = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/unactive/tables?api_password=Project102$_`;

  const response = await fetchWithAuth(apiUrl, { method: "GET" });

  if (!response.ok) {
    throw new Error(`❌ فشل في جلب الطاولات غير النشطة. استجابة الخادم: ${await response.text()}`);
  }

  const data = await response.json();
  return data.data.data;
};
// 2-انشاء طاولات 
export const createTables = async (tableData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/tables`;

  const payload = {
    api_password: "Project102$_",
    count: tableData.count,
    branch_id: tableData.branch_id,
    root_id: tableData.root_id,
  };

  return await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};
// 3-اخفاء طاولات
export const hideTable = async (hideData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/hide/last/table`;

  const payload = {
    api_password: "Project102$_",
    count: hideData.count,
  };

  return await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};
// 4- تعديل بيانات طاولات
// export const updateTableData = async (updateData) => {
//   const subdomain = getSubdomain();
//   const apiUrl = `https://${subdomain}.restocash.app/api/update/tables/data`;

//   const payload = {
//     api_password: "Project102$_",
//     branch_id: updateData.branch_id,
//     from_table: updateData.from_table,
//     to_table: updateData.to_table,
//   };

//   return await fetchWithAuth(apiUrl, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(payload),
//   });
// };
export const updateTableData = async (updateData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/update/tables/data`;

  const payload = {
    api_password: "Project102$_",
    branch_id: updateData.branch_id,
    from_table: updateData.from_table,
    to_table: updateData.to_table,
  };

  console.log("📡 إرسال البيانات إلى API:", apiUrl, payload); // ✅ طباعة البيانات قبل الإرسال

  const response = await fetchWithAuth(apiUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const data = await response.json();
  console.log("📥 رد السيرفر:", data); // ✅ طباعة رد السيرفر

  return data;
};


// 5 انشاء مجموعة للطاولات
export const createGroup = async (branchData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/save/branch?api_password=Project102$_`;

  // 🔹 احصل على التوكين من localStorage أو أي مكان تخزنه فيه
  const token = localStorage.getItem("token"); // تأكد من تخزين التوكين عند تسجيل الدخول

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`, // ⬅️ إرسال التوكين هنا
    },
    body: new URLSearchParams(branchData), // ⬅️ استخدام form-data بدلاً من JSON
  });

  if (!response.ok) {
    throw new Error(`❌ فشل في إضافة الفرع. استجابة الخادم: ${await response.text()}`);
  }

  const data = await response.json();
  return data;
};
// 6 عرض مجاميع الطاولات
export const fetchBranches = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/branch/data?api_password=Project102$_`;

  // 🔹 احصل على التوكين من localStorage أو أي مكان تخزنه فيه
  const token = localStorage.getItem("token"); // تأكد من تخزين التوكين عند تسجيل الدخول

  const response = await fetch(apiUrl, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`, // ⬅️ إرسال التوكين هنا
    },
  });

  if (!response.ok) {
    throw new Error(`❌ فشل في جلب الفروع. استجابة الخادم: ${await response.text()}`);
  }

  const data = await response.json();
  return data.data.data; // ✅ إرجاع بيانات الفروع
};
// 7 تعديل مجموعة طاولات
export const editGroup = async (branchData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/edite/branch?api_password=Project102$_`;

  // 🔹 احصل على التوكين من localStorage أو أي مكان تخزنه فيه
  const token = localStorage.getItem("token"); // تأكد من تخزين التوكين عند تسجيل الدخول

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${token}`, // ⬅️ إرسال التوكين هنا
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams(branchData), // ⬅️ استخدام form-data بدلاً من JSON
  });

  if (!response.ok) {
    throw new Error(`❌ فشل في تعديل الفرع. استجابة الخادم: ${await response.text()}`);
  }

  const data = await response.json();
  return data;
};






/////////////////////////////////////////////الحزائن////////////////////////////////////////////////////////////////////////////
// 1- عرض الحزن
export const fetchAccounts = async () => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/banks`;

  try {
    const response = await fetchWithAuth(apiUrl, { method: "GET" });

    if (!response.ok) {
      throw new Error(`❌ فشل في جلب الحسابات. استجابة الخادم: ${await response.text()}`);
    }

    const data = await response.json();
    console.log("✅ البيانات المستلمة من API:", data); // تحقق من البيانات المسترجعة

    return data.data.map((account) => ({
      id: account.id,
      name: account.name,
      type: account.type,
      balance: account.balance || 0, // ✅ إذا لم يكن هناك رصيد، يرجع 0
      discount_percentage: account.discount_percentage !== undefined ? account.discount_percentage : 0, // ✅ التأكد من عدم وجود `undefined`
      account_number: account.account_number !== undefined ? account.account_number : "غير متوفر", // ✅ إرجاع "غير متوفر" إذا لم يوجد رقم حساب
      roots: Array.isArray(account.roots) ? account.roots : [], // ✅ التأكد من أن `roots` موجودة
    }));

  } catch (error) {
    console.error("❌ خطأ أثناء جلب الحسابات:", error.message);
    return [];
  }
};
// 2-انشاء خزنة
export const createAccount = async (accountData) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/create/new/bank`;

  const formData = new FormData();
  formData.append("api_password", API_PASSWORD);
  formData.append("name", accountData.name);
  formData.append("type", accountData.type === "bank" ? "bank" : "bank_account"); // ✅ تصحيح النوع
  formData.append("discount_percentage", accountData.discount_percentage || 0);
  formData.append("account_number", accountData.account_number || "");

  // ✅ إضافة الفروع المحددة
  accountData.root_ids.forEach((rootId) => {
    formData.append("root_ids[]", rootId);
  });

  console.log("📌 إرسال طلب إنشاء الحساب:", Object.fromEntries(formData.entries()));

  const response = await fetchWithAuth(apiUrl, { method: "POST", body: formData }, true, true);

  if (!response.ok) {
    throw new Error(`❌ فشل في إنشاء الحساب. استجابة الخادم: ${await response.text()}`);
  }

  return response.json();
};
// 3 - تعديل بيانات خزنة
// export const updateAccount = async (accountId, updatedData) => {
//   const apiUrl = `http://moumen6.restocash.app/api/update/bank`;
//   const token = localStorage.getItem("token");

//   if (!token) throw new Error("❌ لا يوجد توكن، الرجاء تسجيل الدخول!");

//   const formData = new URLSearchParams();
//   formData.append("api_password", "Project102$_");
//   formData.append("id", accountId);
//   formData.append("name", updatedData.name);
//   formData.append("type", updatedData.type);  
//   formData.append("discount_percentage", updatedData.discount_percentage); // بدون تحويل إلى رقم
//   formData.append("account_number", updatedData.account_number);

//   console.log("📡 إرسال الطلب إلى API:", formData.toString());

//   const response = await fetch(apiUrl, {
//     method: "POST",
//     headers: {
//       "Authorization": `Bearer ${token}`,
//       "Content-Type": "application/x-www-form-urlencoded",
//     },
//     body: formData,
//   });

//   const responseData = await response.json(); // تحويل إلى JSON مباشرة
//   console.log("📥 استجابة الخادم:", responseData);

//   if (!response.ok) {
//     throw new Error(`❌ فشل في تحديث الحساب. استجابة الخادم: ${JSON.stringify(responseData)}`);
//   }

//   return responseData;
// };
export const updateAccount = async (subdomain, accountId, updatedData) => {
  if (!subdomain) throw new Error("❌ يرجى تحديد الـ subdomain!");

  const apiUrl = `https://${subdomain}.restocash.app/api/update/bank`;
  const token = localStorage.getItem("token");

  if (!token) throw new Error("❌ لا يوجد توكن، الرجاء تسجيل الدخول!");

  const formData = new URLSearchParams();
  formData.append("api_password", "Project102$_");
  formData.append("id", accountId);
  formData.append("name", updatedData.name);
  formData.append("type", updatedData.type);
  formData.append("discount_percentage", updatedData.discount_percentage);
  formData.append("account_number", updatedData.account_number);

  console.log("📡 إرسال الطلب إلى API:", apiUrl, formData.toString());

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formData,
  });

  const responseData = await response.json();
  console.log("📥 استجابة الخادم:", responseData);

  if (!response.ok) {
    throw new Error(`❌ فشل في تحديث الحساب. استجابة الخادم: ${JSON.stringify(responseData)}`);
  }

  return responseData;
};





// اضافة فرع للبنك
export const linkBankToBranch = async (bankId, rootIds) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/add/new/root/bank?api_password=Project102$_`;

  const token = localStorage.getItem("token"); // جلب التوكين من التخزين المحلي

  const response = await fetch(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({
      id: bankId,
      root_ids: rootIds,
    }),
  });

  if (!response.ok) {
    throw new Error(`❌ فشل في ربط الخزنة بالفرع. استجابة الخادم: ${await response.text()}`);
  }

  return await response.json();
};

export const unlinkBankFromBranch = async (accountId, rootIds) => {
  const subdomain = getSubdomain();
  const apiUrl = `https://${subdomain}.restocash.app/api/remove/root/bank?api_password=Project102$_`;

  const token = localStorage.getItem("token"); // 🔹 احصل على التوكين من التخزين المحلي

  const response = await fetch(apiUrl, {
    method: "POST", // ✅ تأكد من أنه POST لأن بعض السيرفرات لا تدعم DELETE مع Body
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`, // ✅ إرسال التوكين
    },
    body: JSON.stringify({
      id: accountId,
      root_ids: Array.isArray(rootIds) ? rootIds : [rootIds], // ✅ التأكد من أن root_ids مصفوفة
    }),
  });

  if (!response.ok) {
    throw new Error(`❌ فشل في إزالة الفرع من الخزنة. استجابة الخادم: ${await response.text()}`);
  }

  return await response.json();
};







